import { useEffect } from "react";
import { _AdquisitionContractModify } from "../../../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../../../core/services/dataBean/useDataBean";
import "./MyAdquisitionContractModify.css"

type AdquisitionContrat = {
    IDAdquisitionContract: number,
    [key: string]: any
}

interface MyAdquisitionContractModifyProps {
    contract: AdquisitionContrat
}

export const MyAdquisitionContractModify = ({ contract }: MyAdquisitionContractModifyProps) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_AdquisitionContractModify);


    const head = [
        { title: 'ID', property: 'IDAdquisitionContractModify', visible: false },
        { title: 'Valor', property: 'AmountModify', visible: true },
        { title: 'Modificación', property: 'NameModify', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Mnemonico', property: 'RPMnemonic', visible: false },
        { title: 'Consecutivo', property: 'RPConsecutive', visible: false },
        { title: 'Fecha Final', property: 'UptoDate', visible: true },
        { title: 'Modificado', property: 'Since', visible: true },
        { title: 'Funcionario', property: 'EntityEmploye', visible: true },
    ]

    useEffect(() => {
        if (contract.IDAdquisitionContract) {
            getLista()
        }
    }, [contract])

    const getLista = () => {
        instance.getAdquisitionContractModifyRender(contract.IDAdquisitionContract).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { console.log(err) })
    }

    const rows = lista || [];

    return (
        <div className="row">
            <div className="col-md-12">

                {Array.isArray(rows) && rows.length > 0 ?
                    <div className="contract-table-container">
                        <div className="contract-table">

                            {/* HEADER */}
                            <div className="contract-table-header">
                                <span>Modificación</span>
                                <span>Descripción</span>
                                <span>Valor</span>
                                <span>Fecha Fin</span>
                                <span>Fecha Registro</span>
                                <span>Funcionario</span>
                            </div>

                            {/* FILAS */}
                            {rows.map((item: any, i: number) => {
                                const data = item.DataBeanProperties || item;

                                return (
                                    <div className="contract-table-row" key={i}>

                                        <span>{data.NameModify}</span>

                                        <span className="truncate">
                                            {data.Description}
                                        </span>

                                        <span>
                                            ${Number(data.AmountModify)?.toLocaleString("es-CO")}
                                        </span>

                                        <span>{data.UptoDate}</span>

                                        <span>{data.Since}</span>

                                        <span>{data.EntityEmploye}</span>

                                    </div>
                                );
                            })}

                            {rows.length === 0 && (
                                <div className="text-center text-muted p-3">
                                    No hay modificaciones
                                </div>
                            )}

                        </div>

                    </div>
                    :
                    <div className="text-center p-5 bg-light rounded-3">
                        <i className="ri-search-eye-line display-4 text-muted"></i>
                        <p className="mt-2">Sin Datos del Expediente</p>
                    </div>
                }
            </div>
        </div>
    );
}